<header class="app-header" [class.app-header--nav-open]="isNavOpen">

  <div class="wrapper app-header__container">

    <!-- BURGER (mobile only, left of logo) -->
    <button
      class="app-header__burger"
      [class.app-header__burger--active]="isNavOpen"
      aria-label="menu"
      [attr.aria-expanded]="isNavOpen"
      (click)="toggleNav()">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- LOGO -->
    <a class="app-header__logo" (click)="redirectHome()">
      <img [src]="logoSVG" alt="Explorer Yummypets">
    </a>

    <!-- NAV MENU (inline desktop / overlay mobile) -->
    <ex-app-nav-menu
      [isOpen]="isNavOpen"
      (close)="isNavOpen = false">
    </ex-app-nav-menu>

    <!-- RIGHT ACTIONS -->
    <div class="app-header__actions">

      @if(isAuthenticated()) {
        <div class="app-header__profile" [class.app-header__profile--open]="isProfileOpen">

          <ex-app-header-actions (avatarClick)="toggleProfile()">
            @if(currentPet()) {
              <span [class]="'ha__avatar radio__img _' + currentPet()?.petType?.id" ></span>
            } @else {
              <span class="app-header__avatar-placeholder">
                <i class="icon i--profile i--white"></i>
              </span>
            }
            
          </ex-app-header-actions>

          <ex-app-profile-menu
            [isOpen]="isProfileOpen"
            (close)="isProfileOpen = false">
          </ex-app-profile-menu>
        </div>

      } @else {

        <div class="app-header__cta">
          <a [routerLink]="'/login'" class="btn btn--ghost btn--sm"
            i18n="@@global.btn.login">Log in</a>
          <a [routerLink]="'/signup'" class="btn btn--primary btn--sm"
            i18n="@@global.btn.join">Sign up</a>
        </div>
      }

    </div>

  </div>

  <!-- SUBNAV (desktop only) -->
  <nav class="app-header__subnav">
    <div class="wrapper app-header__subnav-inner">
      <a class="app-header__subnav-link" [routerLink]="'/question-of-the-day'" routerLinkActive="active">
        <span i18n="@@header.navbar.qod">Questions of the week</span>
      </a>
      <a class="app-header__subnav-link" [routerLink]="'/shelters'" routerLinkActive="active">
        <span i18n="@@header.navbar.shelters">Help for animal shelters</span>
      </a>
    </div>
  </nav>

</header>
